import React from "react";
import { message } from "antd";
import axios from "axios";

const headers = {
  "Content-Type": "application/json",
};
const GoogleApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const axiosInstance = axios.create({
  // baseURL: 'https://api.binsapp.ai/'
  // baseURL: "https://qqa.binsapp.ai/",
  baseURL: "http://localhost:1200/",
  // baseURL: process.env.REACT_APP_BASEURL,
});
// peer --legacy-peer-deps

// console.log('GoogleApiKey', GoogleApiKey);

const handleLogout = () => {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("admin_data");
  localStorage.setItem("isLogin_admin", "false");
  localStorage.setItem("isLogin_admin", false);
  localStorage.removeItem("isLogin_admin");
  window.location.href = "/login";
};

// Set the Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem("admin_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // On the login screen (or with no saved token) a 401 is expected — don't nag with "session expired".
    const onLoginPage = window.location.pathname.startsWith("/login");
    const hasToken = Boolean(window.localStorage.getItem("admin_token"));
    if (error?.response?.status === 401 && hasToken && !onLoginPage) {
      message.error({
        content: (
          <div className="flex items-center gap-3 p-1 text-start">
            <div
              className="bg-[#ff4d4f] rounded-full flex items-center justify-center"
              style={{ minWidth: "18px", width: "18px", height: "18px" }}
            >
              <span className="text-white text-[10px] font-bold">✕</span>
            </div>
            <span
              className="plusJakara_semibold text_dark"
              style={{ fontSize: "14px", whiteSpace: "nowrap" }}
            >
              Session expired. Please login again.
            </span>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => {
                  message.destroy("401_session_expired");
                  handleLogout();
                }}
                className="bg-[#10B981] text-white px-3 py-1.5 rounded-2 text-xs plusJakara_semibold border-0 cursor-pointer hover:opacity-90 active:scale-95 transition-all"
              >
                Login
              </button>
              <button
                type="button"
                onClick={() => message.destroy("401_session_expired")}
                className="bg-gray-200 text-gray-700 px-3 py-1.5 rounded-2 text-xs plusJakara_semibold border-0 cursor-pointer hover:bg-gray-300 transition-all"
              >
                Dismiss
              </button>
            </div>
          </div>
        ),
        key: "401_session_expired",
        icon: <span style={{ display: "none" }} />,
        duration: 0,
      });
    }
    return Promise.reject(error);
  },
);

export { headers };
export { GoogleApiKey };
export default axiosInstance;
